import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import CheckCircleIcon from 'mdi-react/CircleIcon';
import HelpCircleOutlineIcon from 'mdi-react/HelpCircleOutlineIcon';
import AlertCircleOutlineIcon from 'mdi-react/AlertCircleOutlineIcon';
import {
    Col, Row, Modal, Icon, Tag, Spin, Menu, Dropdown, Alert,
} from 'antd';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { get, getVal } from '../../../../../shared/helpers';
import { LeadProfileModals } from './LeadProfileModals';
import { status_tabs } from '../status_tab_statics';
import { SFButton } from '../../../../../components/SF-UI';
import CustomerWantsModal from '../Modals/CustomerWantsModal';
import { changeLeadsStatusRequest } from '../../redux/actions/change_lead_status.actions';
import { assignLeadDeliveryRequestedAgentRequest, assignLeadRequest } from '../../../Manage_retail/redux/actions/assign_lead.actions';
import api from '../../../../App/socket';
import { history } from '../../../../../config/history';
import { getLeadProfileRequest } from '../../redux/actions/get_lead_profile.actions';
import { message_warn } from '../../../../../components/Message';
import { leadManagerChangeLeadsStatusRequest } from '../../../Manager_special/redux/actions/lead_manager_lead_status.actions';
import { getLeadPageType } from '../../../Manage_retail/utils';
import { LEAD_STATUS } from '../../../constants/leadStatuses';
import { POPUP_TYPE } from '../../../constants/popupType';

import { VIN_CHECK } from '../../../constants/vinCheck';
import ArrangeCollectionConfirmModal from '../Modals/ArrangeCollectionConfirmModal';
import config from '../../../../../config/sbf_config';
import BlemishIcon from './components/BlemishIcon';
import { getModalSize } from '../../../utils/getModalSize';
import { getDivisionAbbr } from '../../../utils/getDivisionAbbr';

const MenuItem = Menu.Item;

class LeadProfileHeader extends Component {
    state = {
        visible: false,
        popup_type: '',
        status_name: null,
        status_tabs: [],
        status_css: '',
        showCustomerWants: true,
        hidePopup: false,
        modal: null,
    };

    constructor(props) {
        super(props);
        this.updateManagerSpecial = this.updateManagerSpecial.bind(this);
        this.sendSBFVoucher = this.sendSBFVoucher.bind(this);
        this.closeCustomerWantsModal = this.closeCustomerWantsModal.bind(this);
    }

    sendSBFVoucher(e) {
        e.preventDefault();
        this.props.dispatch({ type: 'SEND_EMAIL_REQUEST', template_id: 4, lead_id: this.props.root_id });
        this.props.dispatch({ type: 'SEND_SMS_REQUEST', template_id: 6, lead_id: this.props.root_id });
    }

    static getDerivedStateFromProps(props) {
        if (props.current_status._id) {
            return {
                status_name: props.current_status.name,
                status_tabs: LeadProfileHeader.showTabsDependOfStatus(props),
                status_css: status_tabs[props.current_status._id].button_style,
            };
        }
        return null;
    }

    static showTabsDependOfStatus = ({
        current_status,
        blemish_report,
        approval,
        customer_details,
        lead_transport,
        bike_hpi_check,
        Lead_valuations: { valuations },
        trade,
    }) => {
        let current_tabs = status_tabs[current_status._id].tabs;
        // check blemish report status Complete
        const check_blemish_report_complete = blemish_report && blemish_report.ref_lead_blemish_report_status === '5c6bb37fb8292a22d8128dfe';

        // CONDITION: if blemish report complete then hide Start Blemish Report button
        if (check_blemish_report_complete) {
            // current_tabs = current_tabs.filter(tab => (tab && tab.tabName !== 'Start Blemish Report'));
        }

        // CONDITION: if status not Arrange Collection, Transport Arranged or Collection Confirmed then hide Cancel Collection button
        if (current_status._id !== '5c4837e08109b9f96e847a49'
            && current_status._id !== '5c8615197e203773e8886802'
            && current_status._id !== '5c87838c47f99d83281b350b') {
            current_tabs = current_tabs.filter((tab) => (tab?.tabName !== 'Cancel Collection'));
            // current_tabs = current_tabs.filter(tab => !/^(Cancel Collection)$/.test(tab.tabName));
        }

        /* if (trade) {
            if (trade.is_trade) {
                current_tabs.push({ icon: 'fa fa-pause', tabName: 'Pending', modal: false });
            }
        } */


        return current_tabs;
    };

    componentDidMount() {
        const { showHpi } = getLeadPageType();
        let hpiModalParams = {};

        if (showHpi) {
            hpiModalParams = { popup_type: POPUP_TYPE.HPICheck, visible: true, show_toggle: false }
        }

        this.setState((prevState) => ({ ...prevState, ...hpiModalParams }));
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.root_id !== this.props.root_id) {
            const _id = history.location.pathname.slice(-24);
            api.socket.off(`model://Lead/${_id}`);
            // api.socket.on(`model://Lead/${_id}`, () => this.props.dispatch(getLeadProfileWithNotesRequest(_id)));
        }
    }

    componentWillUnmount() {
        api.socket.off(`model://Lead/${history.location.pathname.slice(-24)}`);
    }

    updateManagerSpecial(e) {
        e.preventDefault();
        const _id = history.location.pathname.slice(-24);
        let margin = 0;

        if (this.props.Lead_valuations && this.props.Lead_valuations.valuations.length) {
            margin = this.props.Lead_valuations.valuations[this.props.Lead_valuations.valuations.length - 1].retail_price - this.props.Lead_valuations.customer_valuation;
        }

        this.props.dispatch(leadManagerChangeLeadsStatusRequest(_id, false, margin));
    }

    openModal = (event) => {
        this.setState({ popup_type: event.target.innerText, visible: true, show_toggle: false });
    };

    closeCustomerWantsModal = () => {
        this.setState({ showCustomerWants: false });
    }

    closeModal = () => {
        const { dispatch } = this.props;
        const { popup_type } = this.state;

        this.setState({ visible: false }, () => {
            if (popup_type === 'Book Collection') {
                dispatch({ type: 'RESET_TRANSPORT_DATE_DATA' });
            }
        });
    };

    closeArrangeCollectionModal = () => {
        this.setState({ visible: false });
    }

    arrangeCollectionModal = (type) => {
        ArrangeCollectionConfirmModal(type, this.closeArrangeCollectionModal);
    }

    updateStatus = (event) => {
        const {
            root_id, dispatch, customer_details, finance_company, finance_expiry_date,
        } = this.props;
        const {
            customer_collection_date,
            address,
        } = customer_details || {};

        switch (event.target.innerText) {
        case 'In Progress':
            dispatch(changeLeadsStatusRequest(root_id, '5bf2b498f83650911c3e3e80'));
            break;
        case 'In Progress (Trade)':
            dispatch(changeLeadsStatusRequest(root_id, '5f85823bd88a9007b68aa73a'));
            break;
        case 'Pending':
            dispatch(changeLeadsStatusRequest(root_id, '5beabfe7f25bf5f49685abfb'));
            break;
        case 'Pending (Trade)':
            dispatch(changeLeadsStatusRequest(root_id, '5f8574a3d88a9007b68aa732'));
            break;
        case 'Request More Info (Trade)':
            dispatch(changeLeadsStatusRequest(root_id, '5fe25d1a740d6a6ca7acedb8'));
            break;
        case 'Customer Accepted':
            dispatch(changeLeadsStatusRequest(root_id, '5beac00ef25bf5f49685abfd'));
            break;
        case 'Do not Contact':
            if (window.confirm('Are you sure you want to place the lead into Do Not Contact?')) {
                dispatch(changeLeadsStatusRequest(root_id, '5cc1a18319c64e49ff8b13d8'));
            }
            break;
        case 'Send Valuation':
            dispatch(changeLeadsStatusRequest(root_id, '5beabfe7f25bf5f49685abfc'));
            break;
        case 'Send Valuation (Trade)':
            dispatch(changeLeadsStatusRequest(root_id, '5f8574aed88a9007b68aa733'));
            break;
        case 'Customer Accepted (Trade)':
            dispatch(changeLeadsStatusRequest(root_id, '5f858198d88a9007b68aa738'));
            break;
        case 'Customer Declined (Trade)':
            dispatch(changeLeadsStatusRequest(root_id, '5f8582b8d88a9007b68aa73b'));
            break;
        case 'Trade':
            dispatch(changeLeadsStatusRequest(root_id, LEAD_STATUS.pendingTrade, { lead_pot: 'Red' }));
            break;
        case 'Scrap':
            dispatch(changeLeadsStatusRequest(root_id, LEAD_STATUS.doNotWantTrade, { lead_pot: 'Black' }));
            break;
        case 'Customer Wants Too Much (Trade)':
            dispatch(changeLeadsStatusRequest(root_id, '5f85a3ead88a9007b68aa73d'));
            break;
        case 'Customer Already Sold (Trade)':
            dispatch(changeLeadsStatusRequest(root_id, '5f885dc8d88a9007b68aa73f'));
            break;
        case 'Tried To Call - No Answer (Trade)':
            dispatch(changeLeadsStatusRequest(root_id, '5f886009d88a9007b68aa740'));
            break;
        case 'Not Selling (Trade)':
            dispatch(changeLeadsStatusRequest(root_id, '5f886198d88a9007b68aa741'));
            break;
        case 'Poor Condition (Trade)':
            dispatch(changeLeadsStatusRequest(root_id, '5f8863f1d88a9007b68aa742'));
            break;
        case 'We Do Not Want (Trade)':
            dispatch(changeLeadsStatusRequest(root_id, '5f7f248cf0c43201c2a7192c'));
            break;
        case 'Bike In Poor Condition (Trade)':
            dispatch(changeLeadsStatusRequest(root_id, '5f8863f1d88a9007b68aa742'));
            break;
        case 'Bike In Poor Condition':
            dispatch(changeLeadsStatusRequest(root_id, '5beabf6166676f89160edfc2'));
            break;
        case 'Bike Too Old (Trade)':
            dispatch(changeLeadsStatusRequest(root_id, '5f92fafd338def1a9607ae33'));
            break;
        case 'Bike High Mileage (Trade)':
            dispatch(changeLeadsStatusRequest(root_id, '5f92fb12338def1a9607ae34'));
            break;
        case 'On No Buy List':
            if (window.confirm('Are you sure this bike is on the no buy list?')) {
                dispatch(changeLeadsStatusRequest(root_id, '5beabf6166676f89160edfc3'));
            }
            break;
        case 'Already Booked In':
            dispatch(changeLeadsStatusRequest(root_id, '5fb2920966b3d64849b0b609'));
            break;
        case 'Not Bought - Price':
            dispatch(changeLeadsStatusRequest(root_id, '5cc191f25f7d1c0dfbc10f84'));
            break;
        case 'Not Bought - Poor Condition':
            dispatch(changeLeadsStatusRequest(root_id, '5cc191ff5f7d1c0dfbc10f85'));
            break;
        case 'HPI Failed':
            dispatch(changeLeadsStatusRequest(root_id, '5beabf6166676f89160edfc1'));
            break;
        case 'Duplicate (Trade)':
            dispatch(changeLeadsStatusRequest(root_id, '5fd27dc61dc278430e324b21'));
            break;
        case 'We Dont Want':
            if (window.confirm('Are you sure this is a bike we dont want to buy?')) {
                dispatch(changeLeadsStatusRequest(root_id, '5beabe6d66676f89160edd7f'));
            }
            break;
        case 'Request More Information':
            if (window.confirm('By placing a lead in Request more Information, the lead will need to be called to establish the correct bike. Please confirm?')) {
                dispatch(changeLeadsStatusRequest(root_id, '5beabfe7f25bf5f49685abfa'));
            }
            break;
        case 'Arrange Collection':
            if (customer_collection_date && moment(customer_collection_date) >= moment()) {
                if (finance_company !== 'No Finance' && finance_expiry_date && moment(customer_collection_date) > moment(finance_expiry_date)) {
                    this.arrangeCollectionModal(1);
                } else {
                    const { post_code, street } = address;

                    if (post_code && street) {
                        dispatch(changeLeadsStatusRequest(root_id, LEAD_STATUS.arrangeDelivery));
                    } else {
                        message_warn('Before you go to the Arrange Collection status you need to specify street and post code');
                    }
                }
            } else {
                this.arrangeCollectionModal(0);
            }
            break;
        case 'Arrange Collection (Trade)':
            if (customer_collection_date && moment(customer_collection_date) >= moment()) {
                if (finance_company !== 'No Finance' && finance_expiry_date && moment(customer_collection_date) > moment(finance_expiry_date)) {
                    this.arrangeCollectionModal(1);
                } else {
                    const { post_code, street } = address;

                    if (post_code && street) {
                        dispatch(changeLeadsStatusRequest(root_id, LEAD_STATUS.arrangeDeliveryTrade));
                    } else {
                        message_warn('Before you go to the Arrange Collection status you need to specify street and post code');
                    }
                }
            } else {
                this.arrangeCollectionModal(0);
            }
            break;
        case 'Re-Book Collection':
            if (this.props.approval.hpi_check.value) {
                dispatch(changeLeadsStatusRequest(root_id, '5c8615197e203773e8886802'));
            } else {
                message_warn('Before you Re-Book Collection you need to approve HPI check');
            }
            break;
        case 'Assign To Me':
            if (
                this.props.current_status._id === LEAD_STATUS.deliveryRequested
                || this.props.current_status._id === LEAD_STATUS.deliveryRequestedTrade
            ) {
                dispatch(assignLeadDeliveryRequestedAgentRequest(this.props.currentUserId, root_id));
            } else {
                dispatch(assignLeadRequest(this.props.currentUserId, root_id));
            }
            break;
        case 'Duplicate':
            dispatch(changeLeadsStatusRequest(root_id, '5d5ba6ffebd1ef35d423ee2f'));
            break;
            case 'Manage Delivery Requested':
                dispatch(changeLeadsStatusRequest(root_id, '65cb992434ed8e1cf4b3e9b4'));
                break;
            case 'Manage Delivery Requested (Trade)':
                dispatch(changeLeadsStatusRequest(root_id, '65cbc69bb3eef4411a1de6c4'));
                break;
            case 'Twilio Deal':
                dispatch(changeLeadsStatusRequest(root_id, '65ce15630e760ac5454a4c10'));
                break;
            case 'Twilio Deal (Trade)':
                dispatch(changeLeadsStatusRequest(root_id, '65ce15420e760ac5454a4c0f'));
                break;
        default:
            return null;
        }
        this.setState({ showToggle: false });
    };

    getModalTitle = (type) => {
        switch (type) {
        case POPUP_TYPE.startBlemishReport:
            return <>
                        <BlemishIcon isBlemishModal={true} />{' '}
                        {type}
                    </>;
        default:
            return type;
        }
    };

    buildLinkToReferenceBike = (ref_bike_lead) => {
        let refyear = get(this.props.bike_details, 'bike_details.ref_bike_variant.year');

        if (refyear === undefined || refyear === null) {
            refyear = get(this.props.bike_details, 'unmaped_data.bike_year');
        }

        // building link to autotrader.co.uk with params from lead.ref_bike_lead
        const linkHead = 'http://www.autotrader.co.uk/bike-search?sort=price-asc&exclude-writeoff-categories=on';
        const brandFilter = `&make=${get(ref_bike_lead, 'ref_bike_brand.name')}`;
        const modelFilter = `&model=${get(ref_bike_lead, 'ref_bike_model.name') || get(ref_bike_lead, 'unmaped_data.bike_model')}`;
        const postcodeFilter = '&postcode=sk118dz';
        const year = get(ref_bike_lead, 'unmaped_data.bike_year')
            ? `${get(ref_bike_lead, 'unmaped_data.bike_year')}`
            : `${get(ref_bike_lead, 'ref_bike_variant.year')}`;

        const yearFilter = year ? `&year-from=${parseInt(year)}` : '';

        return `${linkHead + brandFilter + modelFilter + postcodeFilter + yearFilter}&seller-type=trade`;
    };

    checkDivisionForHotList = () => {
        const lead_division_id = get(this.props.Lead_marketing, 'ref_lead_source._id');
        // ref_lead_source, id
        // 5be93e5f683059f77dbcef4c - Lead-o-matic
        // 5caf0ab9c2520a5844ef6a89 - SBF part-ex
        if (lead_division_id) {
            return lead_division_id !== '5be93e5f683059f77dbcef4c' && lead_division_id !== '5caf0ab9c2520a5844ef6a89';
        }
        return false;
    };

    checkLeadCreatedDate = () => {
        if (this.props.lead_created_date) {
            const lead_create_date = moment(this.props.lead_created_date).valueOf();
            const currentDateMinus14Days = moment().startOf('day').subtract(14, 'days').valueOf();
            return currentDateMinus14Days <= lead_create_date;
        }
        return false;
    };

    checkLastValuationForHotList = () => {
        const { valuations } = this.props.Lead_valuations;

        if (valuations && valuations.length) {
            const { created_date } = valuations[valuations.length - 1];
            if (created_date) {
                const currentDateMinusSevenDays = moment().subtract(7, 'days').format('YYYY-MM-DD');
                return created_date <= currentDateMinusSevenDays;
            }
            return false;
        }
        return false;
    };

    checkCurrentStatusForHotList = () => {
        const statuses = [
            // pending
            '5beabfe7f25bf5f49685abfb',
            // priced status
            '5c349213b01ff686c64b1dd4',
            // price given
            '5beabfe7f25bf5f49685abfc',
            // in progress
            '5bf2b498f83650911c3e3e80',
        ];
        return statuses.includes(this.props.current_status._id);
    };

    warningHotOrColdList = () => {
        if (get(this.props.bike_details, 'ref_bike_variant.is_hot')
            && this.checkLeadCreatedDate()
            && this.checkLastValuationForHotList()
            && this.checkCurrentStatusForHotList()
            && this.checkDivisionForHotList()
        ) {
            if (getVal(this.props.bike_details, 'ref_bike_variant.hot_margin')) {
                return (
                    <div className="blink">
                        <Alert
                            style={{ marginBottom: 10, borderRadius: 5, fontSize: 16 }}
                            message="Mileage Warning"
                            description={`This bike is on the Hot List. The bike should have a margin of £${getVal(this.props.bike_details, 'ref_bike_variant.hot_margin') || 'not set'}`}
                            type="info"
                            showIcon
                        />
                    </div>
                );
            }
            return null;
        }
        if (get(this.props.bike_details, 'ref_bike_model.we_dont_want')) {
            return (
                <div className="blink">
                    <Alert
                        style={{ marginBottom: 10, borderRadius: 5, fontSize: 16 }}
                        message="No Buy Warning"
                        description="This is a bike we never want to buy"
                        type="warning"
                        showIcon
                    />
                </div>
            );
        }
        if (get(this.props.bike_details, 'ref_bike_variant.is_no_buy')) {
            if (getVal(this.props.bike_details, 'ref_bike_variant.cold_margin')) {
                return (
                    <div className="blink">
                        <Alert
                            style={{ marginBottom: 10, borderRadius: 5, fontSize: 16 }}
                            message="Poor Selling Bike Warning"
                            description={`This bike is a poor selling bike - it MUST have £${getVal(this.props.bike_details, 'ref_bike_variant.cold_margin') || 'not set'}  margin if buying`}
                            type="warning"
                            showIcon
                        />
                    </div>
                );
            }
            return null;
        }
        return null;
    };

    showFakeDetailsWarning = () => {
        const { bike_details } = this.props;
        if (bike_details) {
            if (get(bike_details, 'mileage') && get(bike_details, 'mot_history') && get(bike_details, 'mot_history').length) {
                if (get(bike_details, 'mileage') < get(bike_details, 'mot_history.0.mileage')) {
                    return (
                        <div className="blink">
                            <Alert
                                style={{ marginBottom: 10, borderRadius: 5, fontSize: 16 }}
                                message="Mileage Warning"
                                description="Customer mileage should never be lower than the MOT mileage"
                                type="warning"
                                showIcon
                            />
                        </div>
                    );
                }
            }
        }
    };

    showDuplicatesMessage = () => {
        const bikes_in_stock_is_not_sold = getVal(this.props, 'bike_details.ref_bike_variant.calculated_data.bikes_in_stock_is_not_sold');
        const bike_leads_with_transport_arranged = getVal(this.props, 'bike_details.ref_bike_variant.calculated_data.bike_leads_with_transport_arranged');


        const duplicate_max = getVal(this.props, 'bike_details.ref_bike_variant.duplicate_max');
        const duplicate_margin = getVal(this.props, 'bike_details.ref_bike_variant.duplicate_margin');
        const duplicate_stock_wanted = getVal(this.props, 'bike_details.ref_bike_variant.duplicate_stock_wanted');

        if (bikes_in_stock_is_not_sold || bikes_in_stock_is_not_sold === 0) {
            if (duplicate_max && (bikes_in_stock_is_not_sold === duplicate_max)) {
                return (
                    <div className="blink">
                        <Alert
                            style={{ marginBottom: 10, borderRadius: 5, fontSize: 16 }}
                            s
                            message="Duplicate Stock Alert"
                            description={`We already have ${bikes_in_stock_is_not_sold} of these bike(s) in stock and have reached the maximum amount of bikes for this year and model`}
                            type="warning"
                            showIcon
                        />
                    </div>
                );
            }
            if (
                (duplicate_stock_wanted || duplicate_stock_wanted === 0)
                && bikes_in_stock_is_not_sold < duplicate_max
                && bikes_in_stock_is_not_sold <= duplicate_stock_wanted
                && bikes_in_stock_is_not_sold > 0
                && bike_leads_with_transport_arranged > 0
                && duplicate_margin > 0
            ) {
                return (
                    <div className="blink">
                        <Alert
                            style={{ marginBottom: 10, borderRadius: 5, fontSize: 16 }}
                            message="Duplicate Stock Alert"
                            description={`We already have ${bikes_in_stock_is_not_sold} in stock and ${bike_leads_with_transport_arranged} in transport arranged, you need to use a margin of £${duplicate_margin || 0}`}
                            type="warning"
                            showIcon
                        />
                    </div>
                );
            }
            return null;
        }
    };

    showKnowledge = () => {
        const { ref_bike_model, ref_bike_variant, unmaped_data } = this.props.bike_details;
        const knowledge = get(ref_bike_model, 'knowledge');
        let alert = null;

        if (knowledge?.length) {
            const year = ref_bike_variant ? get(ref_bike_variant, 'year') : get(unmaped_data, 'bike_year');
            const list = knowledge.map((item) => {
                const {
                    note, year_from, year_to, type, _id,
                } = item;
                const hasCorrectType = type === 'All' || type === 'CRM';
                const hasCorrectYear = (!year_from && !year_to) || (year_to >= year && year >= year_from);

                if (hasCorrectType && hasCorrectYear) {
                    return <li key={_id}>{note}</li>;
                }

                return <></>;
            });

            if (list.length) {
                alert = (
                    <Alert
                        style={{ marginBottom: 10, borderRadius: 5, fontSize: 16 }}
                        message="Knowledge"
                        description={<ul>{list}</ul>}
                    />
                );
            }
        }

        return alert;
    }

    vinCheckAlert = () => {
        const { vin_check } = this.props;

        if (vin_check) {
            const commonStyles = { marginBottom: 10, borderRadius: 5, fontSize: 16 };
            const iconStyles = { width: '28px', height: '28px', left: '22px' };

            const vinCheckAlerts = {
                [VIN_CHECK.PASS]: (<Alert
                    style={{ ...commonStyles, background: '#d8e6d9', border: '1px solid #28a745' }}
                    message="VIN Year Check"
                    description="Pass"
                    type="success"
                    showIcon
                    className="VIN-alert"
                />),
                [VIN_CHECK.FAIL]: (<Alert
                    style={{ ...commonStyles, background: '#ffb7b7', border: '1px solid #ff0000' }}
                    message="VIN Year Check"
                    description="Fail - Check year Code"
                    type="warning"
                    showIcon
                    className="VIN-alert"
                    icon={(
                        <AlertCircleOutlineIcon style={{ fill: '#ff0000', ...iconStyles }} />
                    )}
                />),
                [VIN_CHECK.NO_RESULT]: (<Alert
                    style={{ ...commonStyles, background: '#ffecb7', border: '1px solid #f5b541' }}
                    message="VIN Year Check"
                    description="Not Available"
                    type="warning"
                    icon={(
                        <HelpCircleOutlineIcon style={{ fill: '#f5b541', ...iconStyles }} />
                    )}
                    showIcon
                    className="VIN-alert"
                />),
            };

            return vinCheckAlerts[vin_check];
        }

        return null;
    }

    render() {
        const {
            is_manager_special,
            use_live_price,
            served_live_price,
            bike_details,
            lead_pot,
            currentUserId,
            groups,
            current_status_loading,
            assign_lead_loading,
            assign_lead_delivery_requested_agent_loading,
            is_deleted,
            blemish_report,
            trade,
            customer_collection_date,
            current_status,
            lead_division_id,
        } = this.props;

        const showMissingMapping = bike_details && Object.keys(bike_details).length && (!bike_details.ref_bike_brand || !bike_details.ref_bike_model);

        let {
            popup_type,
            visible,
            status_tabs,
            status_css,
            status_name,
        } = this.state;

        const isModalDataLoading = popup_type === POPUP_TYPE.HPICheck && this.props.lead_profile_data_loading;
        const show_finance_warning = blemish_report && blemish_report.ref_lead_blemish_report_status === '5c6bb37fb8292a22d8128dfe';

        if (lead_pot === 'Green') {
            status_tabs = status_tabs.filter((e) => e.tabName !== 'Reject Bike' && e.tabName !== 'Duplicate');
        }

        if (lead_pot === 'Amber') {
            status_tabs = status_tabs.filter((e) => e.tabName !== 'Duplicate');
        }

        // Why we need it ???
        const staticUsersId = [
            '5ca47e1afe7b28575d09fe3a',
            '5e5cebc9948293532e4c1471',
            '5bd162e42799126492f98009',
            '5cc29ae1d003ea3b8ca571bb',
            '5ca479fdfe7b285eb309fd4f',
        ];

        const { isLeadomatic, isDeliveryRequested, isCancelled } = getLeadPageType();

        if (!staticUsersId.includes(currentUserId)) {
            if (!groups.filter((e) => e._id.toString() === '61fbe84a22012f4d276be9a6').length === 0) {
                status_tabs = status_tabs.filter((e) => e.tabName !== 'Arrange Collection');
            }
        } else if (!groups.filter((e) => e._id.toString() === '61fbe84a22012f4d276be9a6').length === 0) {
            status_tabs = status_tabs.filter((e) => e.tabName !== 'Arrange Collection');
        }

        let isBeforeDate = true;

        if (this.props.customer_valuation_date && this.props.selling_reason !== 'Not spoken with customer yet') {
            isBeforeDate = new moment().subtract(24, 'hours').isAfter(new moment(this.props.customer_valuation_date));
        }

        let days = 7;
        let showRevaulationPopup = false;

        if (this.props.Lead_valuations && this.props.Lead_valuations.valuations && this.props.Lead_valuations.valuations.length > 0) {
            const lastValuationDate = this.props.Lead_valuations.valuations[0].created_date;

            if (lastValuationDate && lastValuationDate !== '') {
                showRevaulationPopup = new moment().diff(lastValuationDate, 'days') > 7;
            }

            if (lead_division_id) {
                if (lead_division_id._id.toString() === '61f3b7e42b1c492b481f354d') { // WBAB
                    days = 5;
                    showRevaulationPopup = new moment().diff(lastValuationDate, 'days') > 5;
                }
            }
        }

        if (showRevaulationPopup) {
            status_tabs = status_tabs.filter((e) => e.tabName !== 'Arrange Collection' && e.tabName !== 'Re-Book Collection');
        }


        return (
            <Spin spinning={current_status_loading} tip="Status is updating...">
                <Row>
                    {this.vinCheckAlert()}
                    {
                        showRevaulationPopup && (
                            <>
                                <Alert
                                    style={{ marginBottom: 10, borderRadius: 5, fontSize: 16 }}
                                    message="Revalue Bike"
                                    description={`This bike requires a re-valuation as the last valuation is greater than ${days} days old`}
                                    type="warning"
                                    showIcon
                                />
                            </>
                        )
                    }
                    {
                        !!showMissingMapping && (
                            <Col span={24} style={{ position: 'relative' }}>
                                <div className="blink">
                                    <Alert
                                        style={{ marginBottom: 10, borderRadius: 5, fontSize: 16 }}
                                        message="Map Bike"
                                        description="Bike details are missing, please select a make and/or model"
                                        type="warning"
                                        showIcon
                                    />
                                </div>
                            </Col>
                        )
                    }
                    {
                        // status IS === Delivery Requested
                        current_status._id === LEAD_STATUS.deliveryRequested
                        && (
                            <Col span={24} style={{ position: 'relative' }}>
                                <p>
                                    Customer Wants To Book In For:
                                    {customer_collection_date}
                                </p>
                            </Col>
                        )
                    }
                    <Col span={24} style={{ position: 'relative' }}>
                        {
                            bike_details
                            && (
                                <Fragment>
                                    <h3 className="profileH3">
                                        {
                                            !trade
                                            && (
                                                <Fragment>
                                                    {this.warningHotOrColdList()}
                                                    {this.showFakeDetailsWarning()}
                                                    {this.showDuplicatesMessage()}
                                                </Fragment>
                                            )
                                        }
                                        {
                                            !trade && lead_pot === 'Green' && (
                                                <Fragment>
                                                    <div className="blink">
                                                        <Alert
                                                            style={{ marginBottom: 10, borderRadius: 5, fontSize: 16 }}
                                                            message="Must Price"
                                                            description="This bike must be priced as its within age and mileage and is a bike we want to buy"
                                                            type="info"
                                                            showIcon
                                                        />
                                                    </div>
                                                    <CheckCircleIcon style={{
                                                        fill: 'green',
                                                        width: 40,
                                                        height: 40,
                                                        float: 'left',
                                                        marginRight: 10,
                                                    }}
                                                    />
                                                </Fragment>
                                            )}
                                        {
                                            !trade && lead_pot === 'Amber' && (
                                                <Fragment>
                                                    <div className="blink">
                                                        <Alert
                                                            style={{ marginBottom: 10, borderRadius: 5, fontSize: 16 }}
                                                            message="Maybe Price"
                                                            description="This bike could be priced as its on the border of maximum age or mileage, but is a bike we want to buy"
                                                            type="info"
                                                            showIcon
                                                        />
                                                    </div>
                                                    <CheckCircleIcon style={{
                                                        fill: 'orange',
                                                        width: 40,
                                                        height: 40,
                                                        float: 'left',
                                                        marginRight: 10,
                                                    }}
                                                    />
                                                </Fragment>
                                            )}
                                        {
                                            !trade && lead_pot === 'Red' && (
                                                <Fragment>
                                                    <div className="blink">
                                                        <Alert
                                                            style={{ marginBottom: 10, borderRadius: 5, fontSize: 16 }}
                                                            message="Never Price"
                                                            description={'This bike shouldn\'t be priced as its out of the maximum age or mileage or is a bike we don\'t want to buy'}
                                                            type="info"
                                                            showIcon
                                                        />
                                                    </div>
                                                    <CheckCircleIcon style={{
                                                        fill: '#cc0000',
                                                        width: 40,
                                                        height: 40,
                                                        float: 'left',
                                                        marginRight: 10,
                                                    }}
                                                    />
                                                </Fragment>
                                            )}
                                        {
                                            (served_live_price && !use_live_price)
                                            && (
                                                <div className="blink">
                                                    <Alert
                                                        style={{ marginBottom: 10, borderRadius: 5, fontSize: 16 }}
                                                        message="Served Live Priced "
                                                        description="This bike has been given a live price automatically"
                                                        type="info"
                                                        showIcon
                                                    />
                                                </div>
                                            )
                                        }
                                        {
                                            (served_live_price && use_live_price)
                                            && (
                                                <div className="blink">
                                                    <Alert
                                                        style={{ marginBottom: 10, borderRadius: 5, fontSize: 16 }}
                                                        message="Live Priced Lead Accepted"
                                                        description="This bike has been given a live price automatically and the customer accepted"
                                                        type="info"
                                                        showIcon
                                                    />
                                                </div>
                                            )
                                        }
                                        {this.showKnowledge()}
                                        {
                                            is_deleted
                                                ? <span className="btnLeadNew Red">Deleted</span>
                                                : <span className={status_css}>{status_name}</span>
                                        }
                                        {
                                            is_manager_special
                                            && (
                                                <Fragment>
                                                    {
                                                        !this.props.lead_profile_data_loading
                                                        && (
                                                            <span className="btnLeadNew Green">
                                                                Manager Special. New Margin:
                                                                {
                                                                    (!!this.props.Lead_valuations?.valuations?.length)
                                                                    && (
                                                                        <Fragment>
                                                                            £
                                                                            {this.props.Lead_valuations.valuations[0].retail_price - this.props.Lead_valuations.customer_valuation}
                                                                        </Fragment>
                                                                    )
                                                                }
                                                            </span>
                                                        )
                                                    }
                                                    {
                                                        this.props.lead_profile_data_loading
                                                        && <span className="btnLeadNew Green">Loading Manager Special</span>
                                                    }
                                                </Fragment>
                                            )
                                        }
                                        {
                                            get(this.props.Lead_valuations, 'valuations.0.valuation')
                                            && (
                                                <span>
                                                    &pound;
                                                    {get(this.props.Lead_valuations, 'valuations.0.valuation')}
                                                    &nbsp;-&nbsp;
                                                </span>
                                            )
                                        }
                                        {
                                            bike_details.ref_bike_brand ? bike_details.ref_bike_brand.name : ''
                                        }
                                        &nbsp;
                                        {
                                            (get(bike_details.ref_bike_model, 'name'))
                                                ? get(bike_details.ref_bike_model, 'name')
                                                : get(bike_details.unmaped_data, 'bike_model')
                                        }
                                        &nbsp;
                                        {
                                            get(bike_details.unmaped_data, 'bike_year')
                                                ? get(bike_details.unmaped_data, 'bike_year')
                                                : get(bike_details.ref_bike_variant, 'year')
                                        }
                                        {
                                            get(bike_details, 'mileage')
                                            && (
                                                <Fragment>
                                                    &nbsp;with&nbsp;
                                                    {get(bike_details, 'mileage')}
                                                    &nbsp;miles
                                                </Fragment>
                                            )
                                        }
                                        {
                                            get(this.props.Lead_marketing, 'ref_lead_source.abbr')
                                            && (
                                                <Fragment>
                                                    &nbsp;from&nbsp;
                                                    {getDivisionAbbr(get(this.props.Lead_marketing, 'ref_lead_source.abbr'))}
                                                    &nbsp;
                                                </Fragment>
                                            )
                                        }
                                        {
                                            this.props.assignedTo && this.props.assignedTo.person
                                            && (
                                                <Tag
                                                    color="volcano"
                                                    style={{
                                                        marginLeft: 15,
                                                        marginRight: 0,
                                                        verticalAlign: 'middle',
                                                        display: 'inline-block',
                                                        float: 'right',
                                                    }}
                                                >
                                                    <Spin spinning={assign_lead_loading} size="small">
                                                        Assigned to:&nbsp;
                                                        {this.props.assignedTo.person.first_name}
                                                        &nbsp;
                                                        {this.props.assignedTo.person.last_name}
                                                    </Spin>
                                                </Tag>
                                            )
                                        }
                                        {
                                            this.props.deliveryRequestedAgentAssignedTo?.person
                                            && (
                                                <Tag
                                                    color="blue"
                                                    style={{
                                                        marginLeft: 15,
                                                        marginRight: 0,
                                                        verticalAlign: 'middle',
                                                        display: 'inline-block',
                                                        float: 'right',
                                                    }}
                                                >
                                                    <Spin spinning={assign_lead_delivery_requested_agent_loading} size="small">
                                                        Delivery requested agent:&nbsp;
                                                        {this.props.deliveryRequestedAgentAssignedTo.person.first_name}
                                                        &nbsp;
                                                        {this.props.deliveryRequestedAgentAssignedTo.person.last_name}
                                                    </Spin>
                                                </Tag>
                                            )
                                        }
                                        {
                                            show_finance_warning
                                            && this.props.bike_hpi_check?.pass_checks?.finance === false
                                            && (
                                                <Tag
                                                    color="magenta"
                                                    style={{
                                                        marginLeft: 15,
                                                        marginRight: 0,
                                                        verticalAlign: 'middle',
                                                        display: 'inline-block',
                                                        float: 'right',
                                                    }}
                                                    className="blink_me"
                                                >
                                                    Finance details are outstanding, please scroll down to complete this
                                                    information
                                                </Tag>
                                            )
                                        }
                                        {
                                            !show_finance_warning
                                            && this.props.bike_hpi_check?.pass_checks?.finance === false
                                            && (
                                                <Tag
                                                    color="magenta"
                                                    style={{
                                                        marginLeft: 15,
                                                        marginRight: 0,
                                                        verticalAlign: 'middle',
                                                        display: 'inline-block',
                                                        float: 'right',
                                                    }}
                                                    className="blink_me"
                                                >
                                                    Bike is on finance
                                                </Tag>
                                            )
                                        }
                                        {
                                            get(bike_details, 'ref_bike_model.name') && !get(bike_details, 'unmaped_data.bike_model')
                                            && (
                                                <Icon
                                                    type="tag"
                                                    theme="twoTone"
                                                    twoToneColor="#28a745"
                                                    style={{ marginLeft: 5, verticalAlign: 'middle' }}
                                                />
                                            )
                                        }
                                        {
                                            this.props.hasCompletedBlemish
                                            && (
                                                <Icon
                                                    type="snippets"
                                                    theme="twoTone"
                                                    twoToneColor="#cc0000"
                                                    style={{ marginLeft: 5, verticalAlign: 'middle' }}
                                                />
                                            )}
                                        {
                                            this.props.lead_profile_data_loading
                                            && (
                                                <span
                                                    style={{
                                                        display: 'inline-block',
                                                        color: '#1890ff',
                                                        marginLeft: 15,
                                                        fontSize: 12,
                                                    }}
                                                >
                                                    <Spin />
                                                    <span
                                                        style={{ marginLeft: 5 }}
                                                    >
                                                        Lead profile data still loading...
                                                    </span>
                                                </span>
                                            )
                                        }
                                    </h3>
                                </Fragment>
                            )
                        }
                    </Col>
                </Row>
                {
                    is_deleted
                        ? null
                        : (
                            <div className="header_position">
                                <div className="btnLayout">
                                    {
                                        status_tabs.map((tab) => (
                                            tab.link
                                                ? (
                                                    <a
                                                        key={tab.tabName}
                                                        href={this.buildLinkToReferenceBike(bike_details)}
                                                        target="_NEW"
                                                        className="btnLeadNew"
                                                    >
                                                        <i className={tab.icon} />
                                                        {tab.tabName}
                                                    </a>
                                                )
                                                : (
                                                    <SFButton
                                                        htmlType="button"
                                                        key={tab.tabName}
                                                        style={{ backgroundColor: 'transparent', fontSize: 12 }}
                                                        onClick={
                                                            tab.modal
                                                                ? this.openModal
                                                                : this.updateStatus
                                                        }
                                                        className="btnLeadNew"
                                                        disabled={tab.disabled}
                                                        loading={tab.tabName === 'Start Blemish Report' && this.props.blemish_report === null}
                                                    >
                                                        <i className={tab.icon} />
                                                        {tab.tabName}
                                                    </SFButton>
                                                )
                                        ))
                                    }
                                    {/* Depended By User Group Section */}

                                    {trade
                                        && (
                                            <>
                                                {((!trade.is_trade || trade.is_trade === undefined || trade.is_trade === null) && get(this.props.Lead_marketing, 'ref_lead_source._id') !== '5be93e5f683059f77dbcef4b' && get(this.props.Lead_marketing, 'ref_lead_source._id') !== '61f3b7e42b1c492b481f354d' && get(this.props.Lead_marketing, 'ref_lead_source._id') !== '5caf0ab9c2520a5844ef6a89' && get(this.props.Lead_marketing, 'ref_lead_source._id') !== '620569e44f727bea514edd08')
                                                    && (
                                                        <>
                                                            <SFButton
                                                                htmlType="button"
                                                                key="Manager Special"
                                                                style={{ backgroundColor: 'transparent', fontSize: 12 }}
                                                                onClick={this.sendSBFVoucher}
                                                                className="btnLeadNew"
                                                                disabled={false}
                                                            >
                                                                <i className="fa fa-tag" />
                                                                Send SBF Voucher
                                                            </SFButton>
                                                        </>
                                                    )
                                                }
                                            </>
                                        )
                                    }
                                    {
                                        groups && groups.some((group) => group._id === '5b6a9ee2ba52006858939023' || group._id === '5b6a9ee2ba52006858939024' || group._id === '627a673fbeceb22f7acf41c1')
                                            ? (
                                                <Dropdown overlay={(
                                                    <Menu>
                                                        {groups.some((group) => group._id === '5b6a9ee2ba52006858939023' || group._id === '5b6a9ee2ba52006858939023' || group._id === '5b6a9ee2ba52006858939023' || group._id === '627a673fbeceb22f7acf41c1')
                                                            && (
                                                                <MenuItem style={{ padding: '10px 20px 10px 10px' }}>
                                                                    <Icon type="edit" style={{ marginTop: 5 }} />
                                                                    <span onClick={this.openModal}>Change Status</span>
                                                                </MenuItem>
                                                            )
                                                        }
                                                        <Menu.Divider />
                                                        {groups.some((group) => group._id === '5b6a9ee2ba52006858939023' || group._id === '5b6a9ee2ba52006858939024')
                                                            && (
                                                                <MenuItem style={{ padding: 10 }}>
                                                                    <Icon type="user" />
                                                                    <span onClick={this.openModal}>Assign Lead</span>
                                                                </MenuItem>
                                                            )
                                                        }
                                                    </Menu>
                                                )}
                                                >
                                                    <span style={{ cursor: 'pointer' }}>
                                                        More
                                                        <Icon
                                                            type="down"
                                                            style={{ paddingLeft: 2 }}
                                                        />
                                                    </span>
                                                </Dropdown>
                                            )
                                            : null
                                    }
                                </div>
                                {/* Next/Prev Lead section */}
                                <div>
                                    {!isCancelled
                                         && (
                                             <SFButton
                                                 disabled={!(!this.props.pagination.isLoading && this.props.pagination.previous_lead_id)}
                                                 style={{ backgroundColor: 'transparent', fontSize: 12, marginRight: 5 }}
                                             >
                                                 <Link
                                                     onClick={() => this.props.dispatch(getLeadProfileRequest(this.props.pagination.previous_lead_id))}
                                                     to={{
                                                         pathname: `/Leads/Lead_profile/${this.props.pagination.previous_lead_id}`,
                                                         search: `?isLeadomatic=${isLeadomatic}&isDeliveryRequested=${isDeliveryRequested}`,
                                                     }}
                                                 >
                                                     <i
                                                         className="fa fa-arrow-left"
                                                         aria-hidden="true"
                                                     />
                                                 </Link>
                                             </SFButton>
                                         )
                                    }
                                    <SFButton
                                        type="primary"
                                        style={{ fontSize: 12, marginRight: 5 }}
                                    >
                                        {isCancelled
                                            ? (
                                                <a href={`${config.newCrmUrl}/purchasing/leads/cancelled-collections`}>Lead List</a>
                                            ) : (
                                                <Link
                                                    // eslint-disable-next-line no-nested-ternary
                                                    to={isLeadomatic ? '/Leads/ManageLeadomatic' : isDeliveryRequested ? '/Leads/ManageDeliveryRequested' : '/Leads/Manage'}
                                                >
                                                    Lead List
                                                </Link>
                                            )
                                        }
                                    </SFButton>
                                    {!isCancelled
                                         && (
                                             <SFButton
                                                 disabled={!(!this.props.pagination.isLoading && this.props.pagination.next_lead_id)}
                                                 style={{ backgroundColor: 'transparent', fontSize: 12 }}
                                             >
                                                 <Link
                                                     onClick={() => this.props.dispatch(getLeadProfileRequest(this.props.pagination.next_lead_id))}
                                                     to={{
                                                         pathname: `/Leads/Lead_profile/${this.props.pagination.next_lead_id}`,
                                                         search: `?isLeadomatic=${isLeadomatic}&isDeliveryRequested=${isDeliveryRequested}`,
                                                     }}
                                                 >
                                                     <i
                                                         className="fa fa-arrow-right"
                                                         aria-hidden="true"
                                                     />
                                                 </Link>
                                             </SFButton>
                                         )
                                    }
                                </div>
                            </div>
                        )
                }
                <Modal
                    visible={visible}
                    onCancel={this.closeModal}
                    footer={null}
                    maskClosable={false}
                    width={getModalSize(popup_type)}
                    title={this.getModalTitle(popup_type)}
                >
                    {this.state.visible
                            ? isModalDataLoading ? 
                                <span
                                    style={{
                                        display: 'inline-block',
                                        color: '#1890ff',
                                        marginLeft: 15,
                                        fontSize: 12,
                                    }}
                                >
                                    <Spin />
                                    <span
                                        style={{ marginLeft: 5 }}
                                    >
                                        Data still loading...
                                    </span>
                                </span>
                                :
                                <LeadProfileModals popup_type={popup_type} closeModal={this.closeModal} />
                            : ''}
                </Modal>

                <Modal
                    visible={groups && groups.filter((group) => group._id === '6245aa8981d058772ba87fa0' || group._id === '61fbe84a22012f4d276be9a6' || group._id === '5b6a9ee2ba52006858939023' || group._id === '6022b62cbdb2e9ec24e658a8' || group._id === '5bb1d5980495fed3883c07ac').length === 0 && isBeforeDate && !this.state.is_manager_special && this.state.showCustomerWants && (this.state.status_name === 'Priced' || this.state.status_name === 'Price Given' || this.state.status_name === 'In Progress')}
                    onCancel={this.closeCustomerWants}
                    footer={null}
                >
                    <CustomerWantsModal closeModal={this.closeCustomerWantsModal} />
                </Modal>
            </Spin>
        );
    }
}

const mapStateToProps = (state) => ({
    finance_company: getVal(state.Leads, 'Lead_profile.Lead_general.lead_finance.finance_company'),
    finance_expiry_date: getVal(state.Leads, 'Lead_profile.Lead_general.lead_finance.bought_info.finance_expiry_date'),
    customer_collection_date: getVal(state.Leads, 'Lead_profile.Ref_bike_lead.customer_collection_date'),
    lead_profile_data_loading: getVal(state.Leads, 'Lead_profile.Lead_general.lead_profile_data_loading'),
    lead_created_date: getVal(state.Leads, 'Lead_profile.Lead_general.lead_created_date'),
    current_status_loading: getVal(state.Leads, 'Lead_profile.Lead_general.current_status_loading'),
    lead_division_id: getVal(state.Leads, 'Lead_profile.Lead_general.ref_lead_source'),
    lead_pot: getVal(state.Leads, 'Lead_profile.Ref_bike_lead.lead_pot'),
    vin_check: getVal(state.Leads, 'Lead_profile.Ref_bike_lead.vin_check'),
    is_manager_special: getVal(state.Leads, 'Lead_profile.Ref_bike_lead.is_manager_special'),
    use_live_price: getVal(state.Leads, 'Lead_profile.Ref_bike_lead.use_live_price'),
    served_live_price: getVal(state.Leads, 'Lead_profile.Ref_bike_lead.served_live_price'),
    is_deleted: getVal(state.Leads, 'Lead_profile.Lead_general.is_deleted'),
    leads: getVal(state.Leads, 'Lead_profile.Lead_general.leads'),
    assign_lead_loading: getVal(state.Leads, 'Lead_profile.Lead_general.assign_lead_loading'),
    customer_valuation: getVal(state.Leads, 'Lead_profile.Lead_valuations.customer_valuation'),
    selling_reason: getVal(state.Leads, 'Lead_profile.Lead_valuations.selling_reason'),
    customer_valuation_date: getVal(state.Leads, 'Lead_profile.Lead_valuations.customer_valuation_date'),
    trade: getVal(state.Leads, 'Lead_profile.Lead_general.trade'),
    current_status: getVal(state.Leads, 'Lead_profile.Lead_general.current_status'),
    lead_transport: getVal(state.Leads, 'Lead_profile.Lead_general.lead_transport'),
    assignedTo: getVal(state.Leads, 'Lead_profile.Lead_general.assignedTo'),
    assign_lead_delivery_requested_agent_loading: getVal(state.Leads, 'Lead_profile.Lead_general.assign_lead_delivery_requested_agent_loading'),
    deliveryRequestedAgentAssignedTo: getVal(state.Leads, 'Lead_profile.Lead_general.deliveryRequestedAgentAssignedTo'),
    blemishStep: getVal(state.Leads, 'Lead_profile.Ref_bike_lead.completed_blemish_step'),
    hasCompletedBlemish: getVal(state.Leads, 'Lead_profile.Ref_bike_lead.has_completed_blemish'),
    root_id: getVal(state.Leads, 'Lead_profile.Lead_general.root_id'),
    approval: getVal(state.Leads, 'Lead_profile.Lead_general.approval'),
    bike_hpi_check: getVal(state.Leads, 'Lead_profile.Lead_general.bike_hpi_check'),
    pagination: getVal(state.Leads, 'Lead_profile.Lead_general.pagination'),

    // lead general end

    blemish_report: getVal(state.Leads, 'Lead_profile.Lead_blemish_report.blemish_report'),
    bike_details: getVal(state.Leads, 'Lead_profile.Ref_bike_lead.bike_details'),
    customer_details: getVal(state.Leads, 'Lead_profile.Ref_lead_customer.customer_details'),
    transport_date_data: getVal(state.Leads, 'Lead_profile.Lead_transport.transport_date_data'),
    currentUserId: get(state.App, 'App_content.user._id'),
    groups: getVal(state.App, 'App_content.user.groups'),
    Lead_valuations: getVal(state.Leads, 'Lead_profile.Lead_valuations'),
    Lead_manage: getVal(state.Leads, 'Lead_profile.Lead_manage'),
    Lead_marketing: getVal(state.Leads, 'Lead_profile.Lead_marketing'),
});

export default connect(mapStateToProps, null)(LeadProfileHeader);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/LeadProfileHeader.js